import { useTranslation } from "next-i18next";
import { useState } from "react";
import { useRouter } from "next/router";
import { motion } from "framer-motion";
import { ListWrapper, Menus, Nav } from "styles/jss/Navigation.styles";
import { DefaultIcon } from "components/IconsSvg";
import MenuItems from "./MenuItems";
import LocaleSwitcher from "./LocaleSwitcher";
import useScrollSpy from "utils/hooks/useScrollSpy";
import SearchIcon from "../../components/IconsSvg/SearchIcon";
import SearchDialog from "../../components/Search/SearchDialog";

export default function Navbar({ display, navigation }) {
  const { locale } = useRouter();

  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const panelBackgroundContainer = {
    open: { transform: "perspective(800px) translate3d(0px, 0px, 0px)" },
    close: { transform: "perspective(800px) translate3d(0px, -50px, -50px)" },
  };
  const panelBackground = {
    open: {
      opacity: 1,
      transform: `translate(0px, ${height}px)`,
    },
    close: {
      opacity: 0,
      transform: `translate(0px, 0px)`,
    },
  };
  return (
    <Nav>
      <div
        className={"panelBackgroundWrapper"}
        style={{
          height: `${height}px`,
          visibility: isOpen ? "visible" : "hidden",
        }}
        onMouseLeave={() => setIsOpen(false)}
      >
        <motion.div
          className={"panelBackgroundContainer"}
          style={{
            height: locale === "fa" ? `780px` : "820px",
            transformOrigin: "50% 50%",
          }}
          variants={panelBackgroundContainer}
          animate={isOpen ? "open" : "close"}
        >
          <motion.div
            className={"panelBackground"}
            style={{
              transformOrigin: "50% 0%",
            }}
            variants={panelBackground}
            animate={isOpen ? "open" : "close"}
            transition={{
              type: "just",
            }}
          />
        </motion.div>
      </div>
      <Menus>
        <ListWrapper>
          {navigation.map((link, index) => {
            let hasSubRoute = link?.submenu?.length > 0;
            return (
              <MenuItems
                key={index}
                links={link}
                hasSubRoute={hasSubRoute}
                setOpen={setIsOpen}
                setHeight={setHeight}
              />
            );
          })}
        </ListWrapper>
        <div className={"search_language"}>
          {!display && <LocaleSwitcher />}
          <SearchDialog />
        </div>
      </Menus>
    </Nav>
  );
}
